export default "__VITE_ASSET__DbBMfsKF__"